var lcssafira = lcssafira ||  {};
lcssafira.switchbox = lcssafira.switchbox || {};

;(function(namespace, $){

  var SwitchBox = function(state, body_class) {

    var input_nome,
        label_rg,
        label_cpf,
        tipo_pessoa,
        input_razao;

    input_razao = $('#razao');
    input_nome = $('#nome');
    label_rg = $('#label-rg');
    label_cpf = $('#label-cpf');
    tipo_pessoa = $('#tipo-pessoa');

    this.state = state;
    this.body_class = body_class;

    applyMaskInputs(this.state, this.body_class);

    function changeInputs(state, body_class) {

      this.state = state;
      this.body_class = body_class;
      console.log(this.body_class);

      var label_rg_text,
          label_cpf_text;

      if(state) {
        label_rg_text = label_rg.attr('data-rg');
        label_rg.text(label_rg_text);

        label_cpf_text = label_cpf.attr('data-cpf');
        label_cpf.text(label_cpf_text);

        applyMaskInputs(this.state, this.body_class);
      }

      else {
        label_rg_text = label_rg.attr('data-ie');
        label_rg.text(label_rg_text);

        label_cpf_text = label_cpf.attr('data-cgc');
        label_cpf.text(label_cpf_text);

        applyMaskInputs(this.state, this.body_class);
      }
    }

    tipo_pessoa.on('switchChange.bootstrapSwitch', function(event, state) {
      
      populateRazao(state);
      changeInputs(state, body_class);
    });

    if (tipo_pessoa.is(':checked')) {
      populateRazao(true);
    }
    

    function populateRazao(checkbox_state) {

      input_nome.bind('focusout', function(event) {

        if (checkbox_state) {
          input_razao.attr('value' , input_nome.val());
        }

        else {
          input_razao.attr('value' , '');
        }
      });
    }

    function applyMaskInputs(state, body_class) {

      var SPMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
      },
      spOptions = {
        onKeyPress: function(val, e, field, options) {
            field.mask(SPMaskBehavior.apply({}, arguments), options);
          }
      };

      $('.tel').mask('(00) 0000-0000');
      $('.data').mask('00/00/0000');
      $('.data-no-day').mask('00/0000');
      $('.moeda').mask('000.000.000.000.000,00', {reverse: true});

      if(state) {
        $('.' + body_class + ' .cpf').mask('000.000.000-00', {reverse: true});
      }

      else {
        $('.' + body_class + ' .cpf').mask('00.000.000/0000-00', {reverse: true});
      }

      $('.cel').unmask();
      $('.cel').mask(SPMaskBehavior, spOptions);
      $('.cep').mask('00000-000');
    }
  }

    namespace.SwitchBox = SwitchBox;

})(lcssafira.switchbox, jQuery);

